<template>
  <div id="c1-gigya-container" />
</template>

<script setup>
const config = useRuntimeConfig();
const { t } = useI18n();
const { getInvitePreFill, getInviteDetails } = useInvitationService();
const route = useRoute();
const nuxtApp = useNuxtApp();
const roleRouteMap = {
  '/register-teacher': 'TEACHER',
  '/register-learner': 'LEARNER',
  '/register-parent': 'PARENT'
};

const router = useRouter();
definePageMeta({
  layout: 'user-reg-login-layout',
  middleware: ['page-redirection']
});
useHead({
  title: t(`ONBOARDING.HTML_META.SIGNUP${roleRouteMap[route.path]}.TITLE`)
});
if (process.client) {
  // Set aria-live text(hidden div for screen readers) only after app is mounted
  // This is done to avoid screen readers reading the title twice (once from the div and once from the title tag)
  if (nuxtApp.$isAppMounted.value) {
    usePageTitle().setPageTitle(
      t(`ONBOARDING.HTML_META.SIGNUP${roleRouteMap[route.path]}.TITLE`)
    );
  }
}

// Check if query contains 'ielts true', if yes, then remove the ielts query param from the url.
onBeforeMount(() => {
  if (route.query.ielts) {
    const { ielts, ...restQuery } = route.query;
    router.push({ path: route.path, query: restQuery });
  }
});

onMounted(() => {
  if (getInvitePreFill()) {
    window.addEventListener('GIGYA_AFTER_SCREEN_LOAD', handleAfterScreenLoad);
  }
  window.addEventListener('GIGYA_AFTER_SCREEN_LOAD', (event) => {
    //Check if gigya screen is loaded from the 'ielts' set as true in the onboarding url.
    //If true, the back icon is hidden
    //Hiding of the back button is done irrespective of the value of the invite variable and should be done before 'if (this.invite)'.
    if (route.query.ielts) {
      const backIcon = document.querySelector('#back-icon');
      backIcon.style.display = 'none';
    }
    if (
      event.detail.event.currentScreen === 'gigya-verification-pending-screen'
    ) {
      document.title = t(`ONBOARDING.HTML_META.VERIFYYOUREMAIL.TITLE`);
      usePageTitle().setPageTitle(
        t(`ONBOARDING.HTML_META.VERIFYYOUREMAIL.TITLE`)
      );
    }
  });
  if (window['gigya']) {
    initGigyaScreen(
      '',
      config.public.gigyaScreens[route.path],
      'c1-gigya-container'
    );
  } else {
    window.addEventListener('gigyaLoaded', () =>
      initGigyaScreen(
        '',
        config.public.gigyaScreens[route.path],
        'c1-gigya-container'
      )
    );
  }
});

function handleAfterScreenLoad(data) {
  const inviteDetails = getInviteDetails();
  if (
    data.detail.event.currentScreen == config.public.gigyaScreens[route.path]
  ) {
    setInviteData(inviteDetails);
    disableFieldsAndLinks();
    setInvitationTooltipVisibility(true);
  }
}

function setInviteData(inviteDetails) {
  const emailInputPreset = document.querySelector(
    '#c1-gigya-container .inputEmail input'
  );
  emailInputPreset.value = inviteDetails.email;
  emailInputPreset.setAttribute('disabled', 'disabled');
  if (inviteDetails?.firstName?.trim()) {
    const firstNameInput = document.querySelector(
      "#c1-gigya-container input[name='profile.firstName']"
    );
    firstNameInput.value = inviteDetails.firstName;
  }
  if (inviteDetails?.lastName?.trim()) {
    const lastNameInput = document.querySelector(
      "#c1-gigya-container input[name='profile.lastName']"
    );
    lastNameInput.value = inviteDetails.lastName;
  }
}

function disableFieldsAndLinks() {
  const loginLink = document.querySelector('#c1-gigya-container .nemo-link');
  loginLink.classList.add('d-none');
  const backLink = document.querySelector('#c1-gigya-container .back-arrow');
  backLink.classList.add('disabled');
}

function setInvitationTooltipVisibility(visible) {
  const invitationTooltip = document.querySelector(
    '#c1-gigya-container .invite-tooltip'
  );
  invitationTooltip.classList.toggle('d-none', !visible);
}
</script>
